// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","paragraph":"_1RZCDyBp45CoeE_DKlNw-E _2TpaqYcNX_6lPOdno3N4vC _2yWngtzq90F2CtpHEzi19P","boldFontWeight":"600","colorWhite":"#fff","colorBlackA70":"rgba(14, 19, 24, 0.7)","meta":"In9GIDKg80yDuiKoYKry4","metaItem":"_1YJwz36W8gKvurHghc90vz","metaItemText":"_YOYjC08g_t-COjBVw1Ra","rating":"_1-0n4tDVIY84Th2s_qwNJD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/card/cardGoogleMaps.css
// module id = 935
// module chunks = 0